import { render, staticRenderFns } from "./MenuSetItemCom.vue?vue&type=template&id=10b98309&"
import script from "./MenuSetItemCom.vue?vue&type=script&lang=ts&"
export * from "./MenuSetItemCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports